import { useParams } from "react-router-dom";
import { useEffect,useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import '../styles/sessions.css';

/*const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});*/
import API from "../services/api";
function SessionDetails(){

    const {uuid} = useParams();

    const [events,setEvents] = useState([]);

    useEffect(()=>{

        API.get(
            `/sessions/${uuid}`,
            {
                headers:{
                    Authorization:localStorage.getItem("token")
                }
            }
        ).then(res=>setEvents(res.data));

    },[uuid]);

    return(
        <div className="dashboard-container">
            <Navbar/>
            <div style={{padding: "20px"}}>
                <h2>Session {uuid}</h2>
                <div className="table-wrapper">
                    <table className="dashboard-table">
                        <thead>
                        <tr>
                            <th>Time</th>
                            <th>Event</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Data</th>
                        </tr>
                        </thead>
                        <tbody>
                        {events.map(e => (
                            <tr key={e._id}>
                                <td>{new Date(e.timestamp).toLocaleString("en-US", {timeZoneName: "short"})}</td>
                                <td>{e.event_type}</td>
                                <td>{e.log_type}</td>
                                <td>{e.status}</td>
                                <td>
                                    <pre>{JSON.stringify(e.data, null, 2)}</pre>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
            );
            }

            export default SessionDetails;